/**
 * app/themes/WmGewinnspiel/js/main.js
 *
 * @author Johannes Braun <johannes.braun@swu.de>
 * @package aktionskalender
 * @version 2026-05-19
 */
class WM2026 {

    constructor() {

        // Setup click event handlers for the balls
        const balls = document.querySelectorAll('.ball a');
        balls.forEach(ball => {
            ball.addEventListener('click', ev => {
                ev.preventDefault();
                this.onBallClicked(ev.currentTarget);
            });
        });

        // Setup Parallax Effect
        const prlxContainer = document.getElementById('prlx-scene');
        if (prlxContainer && window.innerWidth >= 1024) {
            this.prlx = new Parallax(prlxContainer, {
                pointerEvents: true,
                scalarY: 3.0,
                scalarX: 10.0
            });
        }
	}


    onBallClicked(el) {
        this.cloneBall = el.cloneNode(false);
        this.cloneBall.id = 'clone-ball';
        document.body.appendChild(this.cloneBall);

        const rect = el.getBoundingClientRect();
        this.cloneBall.style.left = `${rect.left}px`;
        this.cloneBall.style.top = `${rect.top}px`;
        this.cloneBall.style.width = `${rect.width}px`;
        this.cloneBall.style.height = `${rect.height}px`;
        this.cloneBall.innerHTML = '';


        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;

        const lx = (cx > window.innerWidth / 2)
            ? (rect.left + rect.width / 2)
            : (window.innerWidth - rect.left + rect.width / 2)
        ;
        const ly = (cy > window.innerHeight / 2)
            ? (rect.top + rect.height / 2)
            : (window.innerHeight - rect.top + rect.height / 2)

        const destWidth = 2 * (Math.sqrt(Math.pow(lx, 2) + Math.pow(ly, 2)));
        const fact = destWidth / rect.width ;



        const keyframes1 = [
            { transform: `scale(1)`},
            { transform: `scale(${fact})`}
        ];

        const keyframes2 = [
            { transform: `scale(1)`,       opacity: 1.0 },
            { transform: `scale(${fact * 0.5})`,       opacity: 1.0 },
            { transform: `scale(${fact * 0.75})`, opacity: 0.5 }
        ];

        this.cloneBall.animate(keyframes2, {
            duration: 350,
            easing: 'ease-in',
            fill: 'forwards'
        });

        this.showDialog(el);
    }



    showDialog(el) {

        if (this.prlx) {
            this.prlx.disable();
        }

        this.appearKeyframes = [
            {
                transformOrigin: '50% 100%',
                transform: 'translate(0, 50vh) scale(0.33)',
                opacity: 0.33
            },
            {
                transform: 'translate(0, 0) scale(1)',
                opacity: 1
            }
        ];

        this.disappearKeyframes = [
        {
            transformOrigin: '50% 0',
            transform: 'translate(0, 0) scale(1)',
            opacity: 1
        },
            {
                transform: 'translate(0vw, -50vh) scale(0.33)',
                opacity: 0.33
            }
        ];

        this.timing = {
            duration: 200,
            easing: 'ease-out',
            fill: 'both'
        };


        if (el.getAttribute('disabled')) {
            var selector = '.modal--invalid-egg';
            if (el.classList.contains('is-future')) {
                selector += '.invalid-upcoming';
            }
            else if (el.classList.contains('is-past')) {
                selector += '.invalid-past';
            }

            const dlg = document.querySelector(selector);
            if (!dlg) {
                return;
            }
            dlg.showModal();
            const appearAnim = dlg.animate(this.appearKeyframes, this.timing);
            dlg.oncancel = (event) => this.closeAndResetDialog(event, false);
            appearAnim.onfinish = () => {
                const rect = dlg.getBoundingClientRect();
                dlg.style.maxWidth = `${rect.width}px`;
            };
            const closeButtons = dlg.querySelectorAll('.dialog__close-btn');
            closeButtons.forEach(btn => {
                btn.addEventListener('click', (event) => this.closeAndResetDialog(event, false));
            });
        }
        else {
            document.body.classList.add('is-busy');
            const url = el.getAttribute('href') + '/ajax';

            const busyAnim = el.animate({
                    transform: ['scale(0.9)', 'scale(1.15)']
                },
                {
                    duration: 750,
                    easing: 'ease-in-out',
                    iterations: Infinity,
                    fill: 'both',
                    direction: 'alternate'
                }
            );

            // window.setTimeout(() => {
            window.fetch(url)
                .then(response => response.text())
                .then(html => {
                    const dlg = document.querySelector('.modal--prize-view');
                    const contentArea = dlg.querySelector('main');
                    contentArea.innerHTML = html;

                    dlg.showModal();
                    const appearAnim = dlg.animate(this.appearKeyframes, this.timing);
                    dlg.oncancel = (event) => this.closeAndResetDialog(event);

                    appearAnim.onfinish = () => {
                        const rect = dlg.getBoundingClientRect();
                        dlg.style.maxWidth = `${rect.width}px`;
                    };
                    const closeButtons = dlg.querySelectorAll('.dialog__close-btn');
                    closeButtons.forEach(btn => {
                        btn.addEventListener('click', (event) => this.closeAndResetDialog(event));
                    });

                    const ctaBtn = dlg.querySelector('.button--cta');
                    ctaBtn.addEventListener('click', (ev) => this.onCtaBtnClicked(ev));
                })
                .catch(err => console.log(err))
                .finally(() => {
                    document.body.classList.remove('is-busy');
                    busyAnim.cancel();
                });
            // }, 3);
        }

    }


    async disappear(dlg) {
        return new Promise(resolve => {
            const a = dlg.animate(this.disappearKeyframes, this.timing);
            a.onfinish = () => {
                if (this.cloneBall) {
                    document.body.removeChild(this.cloneBall);
                }
                if (this.prlx) {
                    this.prlx.enable();
                }
                resolve();
            };
        });
    }


    closeAndResetDialog(event, reset = true) {
        const dlg = event.currentTarget.closest('dialog');
        if (event) {
            event.preventDefault();
        }


        this.disappear(dlg).then(() => {
            dlg.close();
            if (reset) {
                dlg.querySelector('main').innerHTML = '';
            }
        });
    }




    onCtaBtnClicked(ev) {
        ev.preventDefault();
        const btn = ev.currentTarget;
        const url = btn.getAttribute('href') + '/ajax';
        const dlg = btn.closest('dialog');

		const figure = dlg.querySelector('.prize__figure');
		const f_rect = figure.getBoundingClientRect();
		if (f_rect) {
			figure.animate({ maxHeight: [`${f_rect.height}px`, `0px`]}, { duration: 200, fill: 'both', easing: 'ease-out'});
		}

        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parent = btn.parentNode;
                parent.removeChild(btn);

                const tpl = document.createElement('div');
                tpl.innerHTML = html;
                const form = tpl.querySelector('form').cloneNode(true);

                parent.appendChild(form);

                const formWrapper = form.parentNode;
                const rect = formWrapper.getBoundingClientRect();
                formWrapper.style.maxHeight = '0px';
                formWrapper.style.overflowY = 'hidden';
                formWrapper.animate({ maxHeight: [0, `${rect.height}px`]}, { duration: 200, easing: 'ease-out', fill: 'both'});

                form.onsubmit = (ev) => this.onFormSubmit(ev);
            })
            .catch(err => console.log(err))
            .finally(() => {})
        ;
    }


    onFormSubmit(ev) {
        ev.preventDefault();
        const form = ev.currentTarget;
        const formWrapper = form.parentNode;
        const data = new FormData(form);
        const url = form.action;
        const dlg = form.closest('dialog');

        formWrapper.style.overflowY = 'hidden';
        form.querySelectorAll('.input').forEach(el => el.classList.remove('error'));
        form.querySelectorAll('.error-message').forEach(el => el.parentNode.removeChild(el));
        dlg.classList.add('is-busy');

        const rect1 = formWrapper.getBoundingClientRect();
        const h1 = rect1.height;

        const timing = { duration: 200, fill: 'both', easing: 'ease-out' };
        const closeAnimation = formWrapper.animate({ maxHeight: [`${h1}px`, '3px']}, timing);

        closeAnimation.onfinish = () => {
            fetch(url, {
                method: 'post',
                body: data,
                headers: { Accept: 'application/json' }
            })
            .then(response => response.json())
            .then(async (data) => {
                await new Promise((resolve, reject) => {
                    if (data.success) {
                        // fetch success page
                        fetch(`/participants/added/${data.participant.id}/${data.participant.campaign_id}/ajax`)
                            .then(response => response.text())
                            .then(html => {
                                const tpl = document.createElement('template');
                                tpl.innerHTML = html;
                                const el = tpl.content.querySelector('#ajax-content');
                                formWrapper.innerHTML = '';
                                formWrapper.appendChild(el);
                                resolve();
                            })
                            .catch(err => console.log(err));

                    }
                    else {
                        console.log(data.errors);
                        for (let key in data.errors) {
                            const el = form.querySelector(`[name=${key}]`);
                            const wrapper = el.closest('.input');
                            wrapper.classList.add('error');

                            const mssg = document.createElement('div');
                            mssg.className = 'error-message';

                            for (let ek in data.errors[key]) {
                                mssg.innerHTML += data.errors[key][ek];
                                mssg.innerHTML += '<br>';
                            }
                            wrapper.appendChild(mssg);
                        }
                        resolve();
                    }
                });

                // formWrapper.style.maxHeight = 'max-content';
                const rect2 = formWrapper.firstElementChild.getBoundingClientRect();
                const h2 = rect2.height;
                formWrapper.style.height = '100%';
                formWrapper.animate({maxHeight: [`0px`, `${h2}px`]}, timing);
                dlg.classList.remove('is-busy');
            })
            .catch(err => console.log(err));
        };
    }
}
document.addEventListener('DOMContentLoaded', () => new WM2026());
